import gql from 'graphql-tag';
import * as Apollo from '@apollo/client';
import * as Types from '../../../../../server/graphql/__generated.types';

const defaultOptions = {} as const;
export type UpdateUserAvatarSettingsMutationVariables = Types.Exact<{
  inputs: Types.UpdateUserAvatarSettingsInputs;
}>;

export type UpdateUserAvatarSettingsMutation = {
  __typename?: 'Mutation';
  updateUserAvatarSettings?: {
    __typename?: 'UpdateUserAvatarSettingsMutationResponse';
    code: string;
    success: boolean;
    message: string;
  } | null;
};

export type UpdateTeamAvatarSettingsMutationVariables = Types.Exact<{
  inputs: Types.UpdateTeamAvatarSettingsInputs;
}>;

export type UpdateTeamAvatarSettingsMutation = {
  __typename?: 'Mutation';
  updateTeamAvatarSettings?: {
    __typename?: 'UpdateTeamAvatarSettingsMutationResponse';
    code: string;
    success: boolean;
    message: string;
  } | null;
};

export const UpdateUserAvatarSettingsDocument = gql`
  mutation updateUserAvatarSettings($inputs: UpdateUserAvatarSettingsInputs!) {
    updateUserAvatarSettings(inputs: $inputs) {
      code
      success
      message
    }
  }
`;
export type UpdateUserAvatarSettingsMutationFn = Apollo.MutationFunction<
  UpdateUserAvatarSettingsMutation,
  UpdateUserAvatarSettingsMutationVariables
>;

/**
 * __useUpdateUserAvatarSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateUserAvatarSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAvatarSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAvatarSettingsMutation, { data, loading, error }] = useUpdateUserAvatarSettingsMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUpdateUserAvatarSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserAvatarSettingsMutation,
    UpdateUserAvatarSettingsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateUserAvatarSettingsMutation,
    UpdateUserAvatarSettingsMutationVariables
  >(UpdateUserAvatarSettingsDocument, options);
}
export type UpdateUserAvatarSettingsMutationHookResult = ReturnType<
  typeof useUpdateUserAvatarSettingsMutation
>;
export type UpdateUserAvatarSettingsMutationResult =
  Apollo.MutationResult<UpdateUserAvatarSettingsMutation>;
export type UpdateUserAvatarSettingsMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserAvatarSettingsMutation,
  UpdateUserAvatarSettingsMutationVariables
>;
export const UpdateTeamAvatarSettingsDocument = gql`
  mutation updateTeamAvatarSettings($inputs: UpdateTeamAvatarSettingsInputs!) {
    updateTeamAvatarSettings(inputs: $inputs) {
      code
      success
      message
    }
  }
`;
export type UpdateTeamAvatarSettingsMutationFn = Apollo.MutationFunction<
  UpdateTeamAvatarSettingsMutation,
  UpdateTeamAvatarSettingsMutationVariables
>;

/**
 * __useUpdateTeamAvatarSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateTeamAvatarSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamAvatarSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamAvatarSettingsMutation, { data, loading, error }] = useUpdateTeamAvatarSettingsMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUpdateTeamAvatarSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTeamAvatarSettingsMutation,
    UpdateTeamAvatarSettingsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateTeamAvatarSettingsMutation,
    UpdateTeamAvatarSettingsMutationVariables
  >(UpdateTeamAvatarSettingsDocument, options);
}
export type UpdateTeamAvatarSettingsMutationHookResult = ReturnType<
  typeof useUpdateTeamAvatarSettingsMutation
>;
export type UpdateTeamAvatarSettingsMutationResult =
  Apollo.MutationResult<UpdateTeamAvatarSettingsMutation>;
export type UpdateTeamAvatarSettingsMutationOptions = Apollo.BaseMutationOptions<
  UpdateTeamAvatarSettingsMutation,
  UpdateTeamAvatarSettingsMutationVariables
>;
